import React, { useState } from "react";

// Core Components
import Header from "../components/Header";
import Footer from "../components/Footer";

import Back from "assets/img/top_back.jpg";

function Contact() {
  const [name, setName] = useState("");
  const [kana, setKana] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [text, setText] = useState("");

  const handleChange = (event) => {
    switch (event.target.name) {
      case "name":
        setName(event.target.value);
        break;
      case "kana":
        setKana(event.target.value);
        break;
      case "email":
        setEmail(event.target.value);
        break;
      case "phone":
        setPhone(event.target.value);
        break;
      case "text":
        setText(event.target.value);
        break;
      default:
        console.log("key not found");
    }
  };

  const clearForm = (textarea) => {
    setName("");
    setKana("");
    setEmail("");
    setPhone("");
    setText("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(name);
    console.log(kana);
    console.log(email);
    console.log(phone);
    console.log(text);
    if (name && kana && email && phone && text) {
      const body = {
        name: name,
        kana: kana,
        email: email,
        phone: phone,
        text: text,
      };
      const response = await postContact(body);
      console.log(response);
      clearForm();
      alert("お問い合わせを送信しました。");
    } else {
      alert("全ての項目を入力してください。");
    }
  };

  const postContact = async (body) => {
    const url =
      "https://17wto3amsg.execute-api.ap-northeast-1.amazonaws.com/prod/contact";
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
    const response = await fetch(url, requestOptions);
    return await response.json();
  };

  return (
    <>
      <div className="wrapper">
        <div id="wrap">
          <Header />
          <div id="main_area" style={{ backgroundImage: `url(${Back})` }}>
            <div id="main_text2">
              <p style={{ marginTop: "50px" }}>現在、新規受付を停止しております。</p>
              <p>空きが出た際には、こちらのページでお知らせいたします。</p>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Contact;
